import { useParams } from 'react-router-dom';
import { BreadcrumbPage } from '@/components/ui/breadcrumb';
import type { TestCaseCrumbProps } from './types';

const TestCaseCrumb = ({ param }: TestCaseCrumbProps) => {
    const params = useParams();
    const testCaseId = params[param] ?? 'case';

    return (
        <BreadcrumbPage>
            <div className="flex items-center gap-2 font-mono text-xs">{testCaseId}</div>
        </BreadcrumbPage>
    );
};

export default TestCaseCrumb;
